module.exports = __webpack_public_path__ + "img/shopping-setup-level3.4afbd9dd.png";